import { envURL } from 'helpers/env.helpers';
import { ENVIRONMENT } from 'types';

export const PUBLIC_URL = process.env.PUBLIC_URL ?? '';

export const URLS = {
	authenticate: 'Authentication/authenticate',
	changeProcessStatus: 'InvestmentProcess/ChangeProcessStatus',
	completeRiskQRenewalProcess: 'InvestmentProcess/CompleteRiskQRenewalProcess',
	contractToBeSigned: 'InvestmentProcess/CreateManualSigningContract',
	createAgreementProcess: 'InvestmentProcess/CreateAgreementProcess',
	customer: 'Customer',
	deleteProcess: 'InvestmentProcess/process',
	getAMLQuestions: 'Aml/GetQuestionList',
	getAMLStatus: 'Customer/GetAMLStatus',
	getContractSigners: 'InvestmentProcess/GetContractSigners',
	getIndividualAndCompaniesInfo: 'InvestmentProcess/GetIndividualAndRelatedCompaniesBasicProcessInfo',
	getMifidStatus: 'Customer/MifidStatus/GetMifidStatus',
	getProcesses: 'InvestmentProcess/GetProcesses',
	hasOnlineBankingAccount: 'User/OnlineBanking/HasOnlineBankingAccount',
	interests: 'Customer/fieldofinterests',
	mandates: 'Mandate',
	member: 'Member',
	nationalRegistry: 'NationalRegistry/lookup',
	netbank: 'User/corporate',
	products: 'Product',
	riskq: 'RiskQ',
	riskqResults: 'Customer/riskResults/riskProfileDetails',
	setAMLQuestions: 'Aml/SubmitQuestions',
	sign: 'InvestmentProcess/sign',
	signingAuthority: 'Relation/GetSigningAuthority',
	signingAuthorityMembers: 'Relation/members',
	waiver: 'Waiver',
	external: {
		contentApi: 'https://appscontent.arionbanki.is/api/resources/getbylang',
		eSignatureRedirect: 'account/singlesignon',
		digitalSignature: (env: ENVIRONMENT) => {
			return `https://apps${envURL(env)}.arionbanki.is/digitalsignatures#/overview`;
		}
	},
	content: {
		authentication: '3182afe6-4c01-11ea-bda8-d8d385b77fc4',
		document_signing: '9aa7b826-4c01-11ea-bda8-d8d385b77fc4',
		finish: '054fc70f-4c03-11ea-bda8-d8d385b77fc4',
		general: 'd58b7b12-4f40-11ea-a042-d8d385650d1c',
		interests: 'f95c6ba2-4f48-11ea-a042-d8d385650d1c',
		mandate: '67a562a0-4c01-11ea-bda8-d8d385b77fc4',
		netbank: '89ec00df-4c01-11ea-bda8-d8d385b77fc4',
		products: 'db06f45d-4e85-11eb-8fe9-005056a44557',
		riskq_results: '4550b489-8080-11ea-8b69-d8d385650d1c',
		riskq: '4347e7ef-4c02-11ea-bda8-d8d385b77fc4',
		testRisk: 'a0025f07-0c68-11ef-80e8-005056a49351',
		userboard: '568fcdd1-8ec0-11ea-8543-d8d385b7cb54'
	}
};

export type Endpoints = typeof URLS;
export type PageKeys = keyof typeof URLS.content;

export const API_URL_DEV = 'https://apigw-dev.arionbanki.is/investmentportfolioassessment-external';
export const download_app = 'https://www.arionbanki.is/einstaklingar/fleira/arion-appid';
export const HERO_URL_AV = 'https://www.arionbanki.is/markadir/fleira/markadsvidskipti';
export const IDENTIFIER_URL = 'https://www.arionbanki.is/markadir/fleira/lei-audkenni';
export const investment_protection = 'https://www.arionbanki.is/markadir/fleira/fjarfestavernd';
export const view_agreement = 'https://netbanki.arionbanki.is/nb5/ElectronicDocuments/Index';

export const API_URL_DEV_EMPLOYEE =
	'https://isit-investmentportfolioassessment-internal-webapi-master.dev.service.arionbanki.is';

export const login_to_online_banking = (env: ENVIRONMENT) => {
	return `https://netbanki${envURL(env)}.arionbanki.is/nb5/Securities/Home`;
};

export function buildAPI(apiUrl: string): Endpoints {
	const API: any = URLS;
	return Object.keys(API).reduce((map: any, key) => {
		if ('object' === typeof API[key]) return { ...map, [key]: API[key] };
		map[key] = `${apiUrl}/api/v1/${API[key]}`;
		return map;
	}, {});
}
